module.exports = __webpack_public_path__ + "Assets/1925eb3e-b843-445d-8072-f11f28e0562f.woff2";